import { ChecklightSessionStatus } from '@thesavingsgroup/enums/ChecklightSessionStatus';

export const NEW_APPLICATION_STATUSES: string[] = [
  'SENT_TO_LEAD_PARTNER',
  ChecklightSessionStatus.PENDING_SUBMISSION,
];
